// extracted by mini-css-extract-plugin
export var checkbox = "+6aWm";
export var root = "bnl7C";